/* INDIGREY — Buy it now → bag (not direct checkout). v2 with dedupe.
   Intercepts the buy-now tap at the DOCUMENT level in the CAPTURE phase, so
   it runs before the button's own handler (which fires a checkout submit)
   regardless of script load order. Behaviour: if the selected variant is NOT
   yet in the bag, add it; either way, take the shopper to /cart to review
   items and total. The dedupe avoids the double-quantity when a shopper taps
   Add to bag and then Buy it now for the same piece — quantity changes belong
   to the bag page's stepper. The bag page's Checkout button remains the
   control Razorpay Magic Checkout intercepts, so checkout still opens there. */
(function () {
  document.addEventListener('click', function (e) {
    var buy = e.target && e.target.closest ? e.target.closest('[data-ig-buynow]') : null;
    if (!buy) return;
    var pdp = buy.closest('[data-ig-pdp]');
    if (!pdp) return;
    e.preventDefault();
    e.stopPropagation();            // never reaches the original checkout-submit handler
    var idInput = pdp.querySelector('[data-ig-variant-id]');
    var variantId = idInput && idInput.value;
    if (!variantId || !window.IG || !window.IG.addToCart) { window.location.href = '/cart'; return; }
    var sizeBtn = pdp.querySelector('.ig-rd-pdp__size.is-selected');
    var label = sizeBtn ? sizeBtn.getAttribute('data-letter') : null;
    function addThenGo() {
      window.IG.addToCart(variantId, 1, label).then(function () {
        window.location.href = '/cart';
      }).catch(function () {});
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inBag = (cart.items || []).some(function (it) { return String(it.variant_id) === String(variantId); });
        if (inBag) { window.location.href = '/cart'; return; }
        addThenGo();
      })
      .catch(addThenGo);            // cart unreadable — the tap must still work
  }, true);
})();
